module.exports = __webpack_public_path__ + "img/pexels-maria-pashkova-8943321.c9d16fd1.jpg";